/**
 * Compares two texts in a case-insensitive and diacritic-insensitive manner.
 * Removes all combining diacritical marks in the Unicode range \u0300 to
 * \u036f, leaving only the base letters behind.
 *
 * E.g.: Allows "sapmi" to hit "Sápmi".
 */
export const compareTexts = (text: string | undefined, query: string) => {
  if (!text || !query) {
    return false;
  }

  const normalize = (str: string) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  return normalize(text).includes(normalize(query));
};
